module.exports = __webpack_public_path__ + "static/img/__1623.e604a6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__1623.jpg
// module id = zu8l
// module chunks = 0